/*
  SuperScatto homepage behaviour. Loaded only on the index template (snippets/ss-home-head.liquid).
  - <ssh-carousel>: scroll-snap review slider with dots and arrow keys.
  - Footer link columns: always open on desktop, accordions on mobile.
  - "Cookie" footer links open Shopify's cookie preferences when the privacy banner is available.
*/
(() => {
  const mqMobile = window.matchMedia('(max-width: 749px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!customElements.get('ssh-carousel')) {
    class SshCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ssh-track]');
        if (!this.track) return;
        this.slides = Array.from(this.track.querySelectorAll('[data-ssh-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-ssh-dot]'));
        this.current = 0;

        this.onScroll = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        };
        this.onKeydown = (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          if (!this.classList.contains('is-scrollable')) return;
          event.preventDefault();
          this.goTo(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        };

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('keydown', this.onKeydown);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.track);
        }
        this.update();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.track) {
          this.track.removeEventListener('scroll', this.onScroll);
          this.track.removeEventListener('keydown', this.onKeydown);
        }
      }

      get step() {
        if (this.slides.length < 2) return this.track.clientWidth || 1;
        return this.slides[1].offsetLeft - this.slides[0].offsetLeft || 1;
      }

      update() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        this.classList.toggle('is-scrollable', maxScroll > 2);
        let index = Math.round(this.track.scrollLeft / this.step);
        if (maxScroll > 2 && this.track.scrollLeft >= maxScroll - 2) index = this.slides.length - 1;
        this.setCurrent(index);
      }

      setCurrent(index) {
        this.current = Math.max(0, Math.min(index, this.slides.length - 1));
        this.dots.forEach((dot, i) => {
          if (i === this.current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      goTo(index) {
        const target = Math.max(0, Math.min(index, this.slides.length - 1));
        const left = this.slides[target].offsetLeft - this.slides[0].offsetLeft;
        this.track.scrollTo({ left, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        this.setCurrent(target);
      }
    }
    customElements.define('ssh-carousel', SshCarousel);
  }

  const syncFooterColumns = (root = document) => {
    root.querySelectorAll('[data-ssh-foot-col]').forEach((details) => {
      if (mqMobile.matches) details.removeAttribute('open');
      else details.setAttribute('open', '');
    });
  };

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('[data-ssh-foot-col] > summary');
    if (summary && !mqMobile.matches) event.preventDefault();

    const cookieLink = event.target.closest('[data-ssh-cookie-prefs]');
    if (cookieLink && window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      event.preventDefault();
      window.privacyBanner.showPreferences();
    }
  });

  mqMobile.addEventListener('change', () => syncFooterColumns());
  document.addEventListener('shopify:section:load', (event) => syncFooterColumns(event.target));
  syncFooterColumns();
})();
